import {Card, CardContent} from "@/components/ui/card";
import {Skeleton} from "@/components/ui/skeleton";
import {Icon} from "lucide-react"; // sadece yer tutucu, ikon varmış gibi

const LeagueCardSkeleton = () => {
    return (
        <Card
            className="cursor-pointer overflow-hidden transition-transform w-full border border-dashed min-w-[260px] md:min-w-0 animate-pulse"
        >
            <CardContent className="p-4 bg-gray-100 dark:bg-gray-800 dark:text-white h-full flex flex-col justify-between gap-4">
                <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 rounded-full bg-gray-200 dark:bg-gray-700">
                        <Skeleton className="h-5 w-5  rounded-full"/>
                    </div>
                    <Skeleton className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded"/>
                </div>

                <div className="space-y-2 text-sm">
                    <div className="flex flex-col gap-1">
                        <Skeleton className="h-3 w-3/4 bg-gray-200 dark:bg-gray-700 rounded"/>
                        <Skeleton className="h-3 w-3/5 bg-gray-200 dark:bg-gray-700 rounded"/>
                    </div>
                    <div className="flex flex-col gap-1">
                        <Skeleton className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded"/>
                        <Skeleton className="h-3 w-1/4 bg-gray-200 dark:bg-gray-700 rounded"/>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
export default LeagueCardSkeleton;
